import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/Home.vue'
import YouTubeUploader from '@/views/YouTubeUploader.vue'
import TwitterUploader from '@/views/TwitterUploader.vue'

const routes = [
 { path: '/', name: 'HomePage', component: HomePage },
 { path: '/youtube', name: 'YouTubeUploader', component: YouTubeUploader },
 { path: '/twitter', name: 'TwitterUploader', component: TwitterUploader }
]

const router = createRouter({
 history: createWebHistory(),
 routes
})

export default router